import { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  /** what to show in the report's place, given why it threw */
  fallback: (message: string) => ReactNode;
  /** when it changes, the report is tried again: a new compile, other values */
  resetKey: string;
}
interface State { error: string | null; resetKey: string }

/**
 * A report's Document is code its author wrote; one that throws while
 * rendering must not take the page around it down with it.
 */
export class ReportRenderBoundary extends Component<Props, State> {
  state: State = { error: null, resetKey: this.props.resetKey };

  static getDerivedStateFromError(error: unknown): Partial<State> {
    return { error: error instanceof Error ? error.message : String(error) };
  }

  static getDerivedStateFromProps(props: Props, state: State): Partial<State> | null {
    return props.resetKey !== state.resetKey ? { error: null, resetKey: props.resetKey } : null;
  }

  componentDidCatch(_error: Error, _info: ErrorInfo): void {
    // shown by the fallback; nothing to log to
  }

  render() {
    return this.state.error !== null ? this.props.fallback(this.state.error) : this.props.children;
  }
}
